import { Component, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SyncfusionService } from 'src/app/services/syncfusion.service';

@Component({
  selector: 'app-openpo-column-molecule',
  templateUrl: './openpo-column-molecule.component.html',
  styleUrls: ['./openpo-column-molecule.component.scss']
})
export class OpenpoColumnMoleculeComponent {
  @Input() data: any;
  @Input() header: any;
  infoData: any;
  ELEMENT_DATA: any;
  dialogVisible: boolean = false;
  unavailableData: any;
  showOrderQTY: { code: string; shortage: number }[];
  dataSourcePurchaseOrder = new MatTableDataSource<any>([]);
  objectQTYHeader: string[];
  imgFlag: boolean;
  imgUrl: any;

  constructor(private syncfusion: SyncfusionService) { }

  public onOpenDialog = (event: any, input): void => {
    if (input === "openPOQty") {
      this.infoData = event;
      this.syncfusion
        .getWithCache(
          event.materialCode || event.sku,
          event.locationCode || event.location,
          event.supplierCode
        )
        .then((response) => {
          this.ELEMENT_DATA = response;
          this.dataSourcePurchaseOrder = new MatTableDataSource<any>(
            this.ELEMENT_DATA
          );
          this.dialogVisible = true;
        })
        .catch((error) => {
          this.dialogVisible = false;
        });
    } else if (input === "canOrderQty") {
      this.showOrderQTY = event.shortage_json ? JSON.parse(event.shortage_json) : [];
      this.objectQTYHeader = Object.keys(this.showOrderQTY);
      event.showOrders = true;
    }
  };
  onOverlayClick() {
    this.infoData = [];
    this.dataSourcePurchaseOrder = new MatTableDataSource<any>([]);
    if (this.dialogVisible) {
      this.dialogVisible = false;
      return;
    }
  };
  modifyName(name) {
    if (name == "qty") {
      return "Quantity";
    } else if (name == "code") {
      return "Order Number";
    } else if (name == "purchaseOrderDate") {
      return "Order Date";
    } else {
      return "Supplier";
    }
  }
}
